// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"3d016deb","649":"116369f6","784":"a4fe211c","855":"8292b2f3"}[chunkId] + ".chunk.css";
};